import { isEmpty, isArray, reduce, some } from "lodash"

const EMPTY_OBJECT = {}

export function mapFilters(filters) {
  if (isEmpty(filters)) {
    return EMPTY_OBJECT
  }

  return reduce(filters, (mappedFilters, filterValue, filterId) => {
    if (isSubFilter(filterValue)) {
      mappedFilters[filterId] = mapSubFilter(filterValue)
    } else {
      mappedFilters[filterId] = filterValue
    }
    return mappedFilters
  }, {})
}

// "sub filter" refers to a filter that has an id property, i.e. classifications, tags, position attributes
function isSubFilter(filterValue) {
  return isArray(filterValue) && some(filterValue, v => v.id)
}

function mapSubFilter(filterValue) {
  return reduce(filterValue, (subFilters, subFilter) => {
    subFilters[subFilter.id] = subFilter.options
    return subFilters
  }, {})
}
